module.exports = __webpack_public_path__ + "assets/ca364a241f2c00dd6512182ba77054ba.svg";